import { isDevelopment, isReviewApp, isTest } from "../constants/env";

/**
 * The CF_Authorization cookie is set by the Cloudflare when we access on the super admin page.
 */
const CFAUTH_COOKIE_NAME = "CF_Authorization";

export const getCookieByName = (name: string) => {
  if (typeof document === "undefined") {
    return;
  }
  const cookies = document.cookie.split("; ");
  return cookies.find((cookie) => cookie.startsWith(`${name}=`))?.split(`${name}=`)?.[1];
};

export const isAuthenticatedAsSuperAdmin = () => {
  return isDevelopment || isTest ? false : !!getCookieByName(CFAUTH_COOKIE_NAME);
};

export const removeCFAuthCookie = () => {
  if (typeof document === "undefined") {
    return;
  }
  // To remove a cookie, we rewrite it with a past expiration date
  document.cookie = `${CFAUTH_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const applyCFAuthHeader = () => {
  //We fake the cf authorization token in test environment to help debug
  const cfCookie = isDevelopment || isTest || isReviewApp ? "test_cookie" : getCookieByName(CFAUTH_COOKIE_NAME);
  return {
    headers: {
      ...(cfCookie && { authorization: cfCookie }),
    },
  };
};

export const getCookieByPrefix = (prefix: string) => {
  if (typeof document === "undefined") {
    return;
  }
  const cookies = document.cookie.split("; ");
  const matchingCookie = cookies.find((cookie) => cookie.startsWith(prefix));
  if (!matchingCookie) {
    return;
  }
  const equalsIndex = matchingCookie.indexOf("=");
  return equalsIndex !== -1 ? matchingCookie.substring(equalsIndex + 1) : undefined;
};
